<div
  class="flex w-full py-2 items-center justify-center gap-x-1 my-4"
  [ngClass]="atLeastOneRiskIsAtStrongLevel() ? 'bg-red-200' : 'bg-gray-100'"
>
  <p>{{ resource.offerCustomize.climaticRisks }} :</p>
  @for (climat of arrayClimatic().ClimaticPeril; track $index) {
    <p>{{ $index + 1 }}.</p>
    <p>
      {{ climat.peril.label }}: <b>{{ climat.scoring.label }}</b>
    </p>
    @if ($index < arrayClimatic().ClimaticPeril.length - 1) {
      <span>|</span>
    }
  }
</div>
